"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "100%"
    }
  }, [_c("div", {
    staticClass: "checkbox"
  }, [_c("el-checkbox", {
    on: {
      change: _vm.checkboxChange
    },
    model: {
      value: _vm.checked,
      callback: function callback($$v) {
        _vm.checked = $$v;
      },
      expression: "checked"
    }
  }), _c("div", {
    staticStyle: {
      "margin-left": "10px",
      "line-height": "10px"
    },
    on: {
      click: _vm.change
    }
  }, [_vm._v("我已阅读并知晓"), _c("span", {
    on: {
      click: function click($event) {
        $event.stopPropagation();
        _vm.show = true;
      }
    }
  }, [_vm._v("《客户告知书》")])])], 1), _c("van-dialog", {
    attrs: {
      title: "康复服务客户知情同意书",
      "show-cancel-button": ""
    },
    on: {
      confirm: _vm.confirm
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c("div", {
    staticClass: "fz12 z6 tlddq mt5",
    staticStyle: {
      height: "500px",
      overflow: "auto",
      padding: "10px"
    }
  }, [_vm._v(" 尊敬的客户您好： "), _c("br"), _c("br"), _vm._v(' 感谢您选择泓杰春蕴医疗健康科技（北京）有限公司（以下简称"本公司"）提供的"康复入院、私人康复师、床位费用减免、以及远程康复指导"等服务。为了保障您的权益，确保您充分理解本服务的性质、内容、流程、限制及您的权利与义务，请您在申请或使用本服务前，务必仔细阅读本知情同意书的全部内容。如有任何疑问，请随时咨询您的服务专员或致电本公司客服热线 [客服电话]。 '), _c("br"), _c("br"), _c("p", {
    staticClass: "z3 b mt5"
  }, [_vm._v("一、 康复入院绿通服务内容说明")]), _vm._v(" 1. 服务性质：康复入院绿通服务是本公司在您符合服务条件的前提下，为您协调安排的合作医疗机构（医院）资源，旨在协助您更快地获得指定疾病相关的康复入院、私人康复师、住院床位费用减免（医保外）、远程康复指导（请根据实际服务内容勾选或填写：□ 康复入院绿通位安排 □ 私人康复师 □ 床位费用减免（医保外）□ 远程康复指导）。该服务是本公司提供的增值服务，不替代正常的医疗流程，也不保证最终的治疗效果。 "), _c("br"), _c("br"), _vm._v(" 2. 适用条件： "), _c("br"), _vm._v(" * 您必须是本公司指定保险产品的有效被保险人，且该产品包含康复服务权益。 "), _c("br"), _vm._v(" * 您所患疾病需符合康复服务约定的保障范围（为首次患重大疾病，具体详见您的保险合同条款或服务手册）。 "), _c("br"), _vm._v(" * 您需提供必要的、经本公司认可的初步医学诊断证明材料。 "), _c("br"), _vm._v(" * 服务需在康复服务服务网络覆盖的合作医院范围内使用。 "), _c("br"), _c("br"), _vm._v(" 3. 服务流程概述（具体流程以实际指引为准）： "), _c("br"), _vm._v(" * 申请：当您需要康复服务时，请通过 [指定申请渠道，如：服务热线、APP、微信公众号] 联系本公司康复服务专员提出申请，并提供所需信息（身份信息、保单信息、初步诊断信息等）。 "), _c("br"), _vm._v(" * 审核：本公司将根据您提供的信息、保险合同约定及服务规则进行审核，确认您是否符合服务条件。 "), _c("br"), _vm._v(" * 协调安排：审核通过后，本公司将启动服务，尽力协调合作医院资源，为您安排 "), _c("br"), _vm._v(" * 反馈：本公司服务专员将及时向您反馈协调结果（如：预计等待时间、安排好的医院及专家信息、就诊/入院指引等）。 "), _c("br"), _vm._v(" * 就诊/入院：您需按照协调结果及医院要求，携带相关证件、资料按时前往指定医院办理手续。您仍需遵守医院的正常挂号、缴费、诊疗等流程和规定。 "), _c("br"), _c("br"), _vm._v(" 4. 服务价值：本公司旨在通过资源协调，尽力缩短您在合作医院获得 [住院 / 专家门诊 / 专家手术] 的等待时间，为您就医提供便利。本服务本身不收取额外费用（即本公司不向您收费）。 "), _c("br"), _c("br"), _c("p", {
    staticClass: "z3 b mt5"
  }, [_vm._v("二、 重要须知与潜在限制")]), _vm._v(" 1. 时效性： "), _c("br"), _vm._v(" * 本公司将尽力在承诺的服务响应时间内（如：4小时内初步响应，3-5个工作日内反馈协调结果）为您提供服务。 "), _c("br"), _vm._v(" * 床位/预约的具体时间受限于合作医院的实际资源状况（如：床位周转率、专家排班、手术室安排、急诊优先原则等）。本公司无法保证一定能立即或在特定时间内安排成功。 "), _c("br"), _vm._v(" * 高峰时段（如流行病高发期）、特定专家资源紧张等因素可能导致协调时间延长或暂时无法安排。 "), _c("br"), _c("br"), _vm._v(" 2. 资源限制： "), _c("br"), _vm._v(" * 康复服务依赖于与本公司签约的合作医院网络及其提供的资源配额。 "), _c("br"), _vm._v(" * 服务仅限于合作医院网络内。若您指定的医院不在合作网络内，或合作网络内医院无法满足您的需求，本公司可能无法提供服务或只能提供网络内替代方案。 "), _c("br"), _c("br"), _vm._v(" 3. 服务结果的不确定性： "), _c("br"), _vm._v(' * 康复服务仅负责协调安排就医/入院的"通道"，不涉及任何具体的临床诊断、治疗方案制定或医疗行为。 '), _c("br"), _vm._v(" * 最终的诊断结果、治疗方案、手术效果、住院时长、医疗费用等均由接诊医院和医生根据您的实际病情决定，与本公司及绿通服务无关。本公司不就医疗结果提供任何保证或承担责任。 "), _c("br"), _vm._v(" * 康复服务中床位费用减免服务您必须有缴纳国家的医保（包含、职工医保、农村合作医疗等，但是不包含商业保险），否则不给予报销或者减免 "), _c("br"), _c("br"), _vm._v(" 4. 客户配合义务： "), _c("br"), _vm._v(" * 您需提供真实、准确、完整的个人信息、保单信息和初步诊断信息。提供虚假信息可能导致服务终止或失效。 "), _c("br"), _vm._v(" * 您需及时响应本公司服务专员的沟通，并根据要求补充提供材料。 "), _c("br"), _vm._v(" * 您需按协调好的时间、地点前往医院，并遵守医院的规章制度。若您未能按时前往，可能导致预约/床位失效，且重新安排可能需要时间或无法保证。 "), _c("br"), _vm._v(" * 您需自行承担前往医院的就诊交通、住宿等费用（除非合同另有约定）。 "), _c("br"), _c("br"), _vm._v(" 5. 医疗费用： "), _c("br"), _vm._v(" * 康复服务本身是免费的（指本公司不收费）。 "), _c("br"), _vm._v(" * 在医院发生的所有医疗费用（挂号费、检查费、药品费、治疗费、手术费、住院费等）均需由您自行承担，或根据您所购买的医疗保险合同进行理赔结算。康复服务不包含任何医疗费用的垫付或担保（除服务中规定的条款）。 "), _c("br"), _c("br"), _vm._v(" 6. 责任免除（核心条款，请务必清晰表述）： "), _c("br"), _vm._v(" * 因以下原因导致康复服务未能提供、延迟提供或未能达到预期效果，本公司不承担责任： "), _c("br"), _vm._v(" * 您不符合服务申请条件或提供的信息不真实、不完整。 "), _c("br"), _vm._v(" * 合作医院资源不可用（如：无空余床位、专家停诊、设备故障、突发公共卫生事件等）。 "), _c("br"), _vm._v(" * 您未能按要求配合（如：未按时就诊、未提供必要材料）。 "), _c("br"), _vm._v(" * 不可抗力因素（如：自然灾害、战争、疫情管制、通信中断等）。 "), _c("br"), _vm._v(" * 医院内部管理流程、诊疗规范或政策调整。 "), _c("br"), _vm._v(" * 非本公司合作网络内的医院需求。 "), _c("br"), _vm._v(" * 因您自身健康状况变化导致原安排无法执行。 "), _c("br"), _vm._v(" * 本公司不就通过绿康复服务安排的医院、医生的诊疗行为、医疗结果、服务质量或医疗差错承担责任。相关的医疗责任由接诊医院和医生承担。 "), _c("br"), _c("br"), _c("p", {
    staticClass: "z3 b mt5"
  }, [_vm._v("三、 个人信息处理授权（核心条款）")]), _vm._v(" 1. 收集与使用目的：为了为您提供绿通服务（包括资格审核、服务协调、进度反馈、服务评价及改进），本公司需要收集、使用您及被安排就诊者的相关个人信息，包括但不限于： "), _c("br"), _vm._v(" * 身份信息（姓名、身份证号、联系方式） "), _c("br"), _vm._v(" * 保单信息 "), _c("br"), _vm._v(" * 健康信息和医疗信息（如：初步诊断结论、病历资料、检查报告 - 此为敏感个人信息） "), _c("br"), _vm._v(" * 服务过程信息（申请记录、沟通记录、安排结果） "), _c("br"), _c("br"), _vm._v(" 2. 信息共享：本公司将在必要范围内将您的相关信息（特别是必要的健康医疗信息）共享给： "), _c("br"), _vm._v(" * 合作医院及其相关医护人员，以便医院进行接收评估、资源安排和诊疗准备。 "), _c("br"), _vm._v(" * 监管机构（如依法要求）。 "), _c("br"), _vm._v(" * 关联公司（如服务涉及）。 "), _c("br"), _c("br"), _vm._v(" 3. 敏感个人信息处理您的健康医疗等敏感个人信息，是为了提供康复服务的核心必需目的。我们将采取严格的保护措施。 "), _c("br"), _c("br"), _vm._v(" 4. 您的权利：您有权访问、更正、删除您的个人信息（法律法规规定的保存期限或另有规定除外），撤回对本同意书中个人信息处理的授权（撤回授权可能导致绿通服务无法继续提供）。行使权利请联系 [联系方式，如：客服电话、邮箱、邮寄地址]。 "), _c("br"), _c("br"), _vm._v(" 5. 授权有效期：本授权自您签署本同意书之日起生效，至康复服务完成且相关法律规定的个人信息保存期限届满之日终止，或至您撤回授权之日终止（以较早者为准）。 "), _c("br"), _c("br"), _c("p", {
    staticClass: "z3 b mt5"
  }, [_vm._v("四、 客户声明与同意（核心签署部分）")]), _vm._v(" 本人已认真阅读、完全理解并接受本《康复服务客户知情同意书》的全部内容（特别是加粗字体部分），尤其是关于服务限制、责任免除以及个人信息处理的条款。 "), _c("br"), _c("br"), _vm._v(" * 本人确认本人符合申请绿通服务的条件，并保证所提供的信息真实、准确、完整。 "), _c("br"), _vm._v(" * 本人理解绿通服务的性质和流程，知晓其时效性和资源限制，对服务结果的不确定性有充分认识。 "), _c("br"), _vm._v(" * 本人理解并接受本公司的责任免除范围。 "), _c("br"), _vm._v(" * 本人自愿授权泓杰春蕴医疗健康科技（北京）有限公司康复服务之目的，收集、使用、共享（特别是向合作医院共享）本人必要的个人信息（包括健康医疗信息）。 "), _c("br"), _vm._v(" * 本人承诺将积极配合康复服务的提供 "), _c("br"), _c("br"), _c("p", {
    staticClass: "tr red",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("泓杰春蕴医疗健康科技（北京）有限公司")])])])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;